interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  const btnBase =
    "min-w-[36px] h-9 px-3 rounded-md text-sm font-medium flex items-center justify-center cursor-pointer transition-colors whitespace-nowrap";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} ${
          current === 1
            ? "text-foreground-300 cursor-not-allowed"
            : "text-foreground-700 bg-background-50 border border-background-200 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${btnBase} ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "text-foreground-700 bg-background-50 border border-background-200 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} ${
          current === total
            ? "text-foreground-300 cursor-not-allowed"
            : "text-foreground-700 bg-background-50 border border-background-200 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}